<template>
  <div class="body">
    <div class="plate_title">
      <div class="plate_title_name">快讯列表</div>
    </div>
    <div class="bb p30">
      <div class="mb20">
        <el-button type="primary" @click="showFrom">添加</el-button>
      </div>
      <!-- 数据列表 -->
      <div v-loading="listLoading">
        <div class="mb20">
          <el-table :data="list" height="80vh" style="width: 100%">
            <el-table-column label="ID" width="120" prop="id">
            </el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="标题"
              width="300"
              prop="title"
            >
            </el-table-column>
            <el-table-column label="内容" prop="content"> </el-table-column>
            <el-table-column
              label="时间"
              width="220"
              prop="update_time"
            ></el-table-column>
            <el-table-column label="操作" width="100" align="center">
              <template #default="scope">
                <el-button
                  type="danger"
                  size="default"
                  @click="handleDelete(scope.row.id)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- <div>
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-size="pageSize"
            layout="total, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div> -->
      </div>
    </div>
    <!-- 弹出表单 -->
    <el-dialog
      width="900px"
      v-model="formShow"
      :title="formTitle"
      :before-close="handleClose"
    >
      <div class="flex">
        <el-form ref="form" :model="form" label-width="80px">
          <el-form-item label="标题">
            <el-input v-model="form.title"></el-input>
          </el-form-item>
          <el-form-item label="创建时间">
            <el-date-picker
              v-model="form.create_time"
              type="datetime"
              placeholder="选择日期时间"
              value-format="YYYY-MM-DD HH:mm:ss"
            />
          </el-form-item>
          <el-form-item label="内容">
            <el-input
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 10 }"
              v-model="form.content"
            ></el-input>
          </el-form-item>
          <el-form-item label="来源">
            <el-input v-model="form.source"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from "@/utils/request";
import E from "wangeditor";
import companyList from "@/utils/futuresCompanies";
import { Delete, Plus } from "@element-plus/icons-vue";
const OSS = require("ali-oss");
export default {
  components: {
    Plus,
    Delete,
  },
  data() {
    return {
      listLoading: false,
      list: [],
      total: 0,
      formShow: false,
      formTitle: "",
      form: {
        title: "",
        create_time: "",
        content: "",
        source: "",
        msg_type: "from_rsr",
      }, // 提交表单信息
    };
  },
  mounted() {
    window.onmessageSocket = this.onmessage;
    this.getList();
  },
  methods: {
    onmessage(e) {},
    // 信息列表
    async getList() {
      this.listLoading = true;
      const res = await request.post("/vce_gm/v1/dpzl_from_rsr/", {
        limit: "20",
      });
      this.list = res.data.dta;
      this.listLoading = false;
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    async onSubmit() {
      var form = this.form;
      var obj = { ...form };
      if (!obj.title) {
        this.$message.error("请填写标题");
        return false;
      }
      if (!obj.create_time) {
        this.$message.error("请填创建时间");
        return false;
      }
      if (!obj.content) {
        this.$message.error("请填写内容");
        return false;
      }
      const res = await request.post("/vce_gm/v1/dpzlts2/", { data: obj });
      if (res.code === 1) {
        this.$message.success("添加成功");
      } else {
        this.$message.success(res.message);
      }
      this.getList();
      this.formShow = false;
    },
    showFrom() {
      var d = new Date();
      var year = d.getFullYear();
      var month =
        d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
      var date = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
      var days = new Array("日", "一", "二", "三", "四", "五", "六");
      var day = d.getDay();
      var hour = d.getHours() < 10 ? "0" + d.getHours() : d.getHours();
      var min = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();
      var sec = d.getSeconds() < 10 ? "0" + d.getSeconds() : d.getSeconds();
      var cori_date = year + "-" + month + "-" + date;
      var cori_time = hour + ":" + min + ":" + sec;
      this.form.create_time = cori_date + " " + cori_time;
      this.formShow = true;
      // this.currentTime = cori_time;
      // this.currentWeek = "星期" + days[day];
    },
    handleDelete(id) {
      this.$confirm("确认删除该数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.handleDeleteApi(id);
      });
    },
    async handleDeleteApi(id) {
      const res = await request.post("/vce_gm/v1/dpzl_del/", {
        id: id.toString(),
      });
      if (res.code === 1) {
        this.$message.success("删除成功");
      } else {
        this.$message.success(res.message);
      }

      this.getList();
    },
  },
};
</script>

<style scoped>
.body {
  height: 100vh;
}

.plate_title {
  background-color: #f8fcff;
  font-size: 16px;
  font-weight: 500;
  box-sizing: border-box;
  padding: 18px 0;
  border-top: 1px solid #ebeced;
  border-bottom: 1px solid #ebeced;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.plate_title_name {
  position: relative;
  line-height: 16px;
  padding-left: 30px;
}

.plate_title_name::before {
  content: "";
  position: absolute;
  left: 13px;
  width: 4px;
  height: 16px;
  background-color: #5389f5;
  border-radius: 5px;
}

.head > div {
  margin: 0 30px 20px 0;
  display: flex;
  align-items: center;
}

.head > div > div:first-child {
  margin-right: 10px;
  /* margin-bottom: 10px; */
}

.el-form {
  width: 90%;
}

.icon_del {
  display: block;
  width: 26px;
  height: 26px;
  margin-left: 10px;
}

.avatar-uploader_div {
  width: 148px;
  height: 148px;
  display: block;
  position: relative;
}

.avatar-uploader .avatar {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.zhezhao {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  background-color: rgba(0, 0, 0, 0.6);
}

.zhezhao:hover {
  opacity: 1;
}

/deep/.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: var(--el-transition-duration-fast);
}

/deep/.avatar-uploader .el-upload:hover {
  border-color: var(--el-color-primary);
}

/deep/.el-icon.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 148px;
  height: 148px;
  text-align: center;
}
</style>
